import axios from 'axios';
import notify from './notify';
import ajaxapi from "./api.js";


axios.interceptors.request.use(config => {
	//config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	let sessionUser = localStorage.getItem('userData') ? localStorage.getItem('userData') : sessionStorage.getItem('userData');
	let sessionUserData = JSON.parse(sessionUser);
	(sessionUserData &&sessionUserData.token) ? config.headers['AuthToken'] = sessionUserData.token : "";

	return config;
}); //统一上传token 

var nums = 0;

axios.interceptors.response.use(response => {
	// console.log(response,'response');
	nums++;
	if (typeof (response.data) === "string") {
		try {
			response.data = JSON.parse(response.data);
		} catch (e) {
			console.log("axios error:", e, response);
		}
	}

	var axiosUserData = {};
	let dataddd = localStorage.getItem('userData') ? localStorage.getItem('userData') : sessionStorage.getItem('userData');
	if (typeof (dataddd) == 'object') {
		axiosUserData = dataddd;
	} else {
		axiosUserData = JSON.parse(dataddd);
	}


	// window.tipspopFun({lock:true,type:"permission"});
	// 100100 token缺失 100101token无效 100102 token已过期
	var tokentext = "";
	if (response.data.code == 100100) {
		tokentext = "用户令牌缺失，请重新登录";
		notify.error(tokentext);

	} else if (response.data.code == 100101) {
		tokentext = "用户令牌无效，请重新登录";
		notify.error(tokentext);
	} else if (response.data.code == 10010) {
		tokentext = "您的账号已在别处登录，如要继续使用请重新登录";
		notify.error(tokentext);
	}else if (response.data.code == 100102) {
		tokentext = "用户令牌已过期，如要继续使用请重新登录";
		notify.error(tokentext);
	} else if (response.data.code == 204) {
		window.loadingFun(false);
		notify.error('访问过于频繁，如需继续访问，可联系我们。');
		return;
	}
	return response || {
		data: {
			success: false
		}
	};
}, error => {
	console.error('error', error);
	if (!error || !error.response) {
		notify.error('未知错误！');
		return error;
	}

	if (error.response.status === 401) {
		notify.error('未授权!');
	} else {
		notify.error('系统出错：' + error.response.status);
	}
	return false;
});

export default axios;
